import React, { useState } from 'react'
import { Tooltip, Box } from '@mui/material'
import { chatbotEnabled } from './config'
import ChatBot from './ChatBot'
import { Icon } from 'packages/eid-icons'

const fabStyles = (align) => ({
    position: 'fixed',
    bottom: 20,
    ...(align === 'right' ? { right: 20 } : { left: 20 }),
    width: 56,
    height: 56,
    borderRadius: '50%',
    background: 'var(--card-bg, #fff)',
    border: '2px solid var(--card-border, #94a3b8)',
    boxSizing: 'border-box',
    zIndex: 2147483646,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    transition: 'transform 0.2s ease, border-color 0.2s ease',
    '&:hover': {
        transform: 'scale(1.05)',
        borderColor: 'var(--main-text-secondary, #64748b)',
    },
    '&:focus': {
        outline: 'none',
    },
})

const statusDotStyles = {
    position: 'absolute',
    top: 4,
    right: 4,
    width: 12,
    height: 12,
    borderRadius: '50%',
    background: 'var(--success-color, #22c55e)',
    border: '2px solid var(--card-bg, #fff)',
    boxSizing: 'border-box',
}

/**
 * Floating chat button. Renders when CHATBOT_ENABLED is true in config.
 * Optional locale prop for app-specific language (e.g. from useCurrentPerson).
 * align controls which side of the screen the chat anchors to ('left' | 'right'). Default 'left'.
 */
const ChatBotFloatingTrigger = ({ locale, align = 'left', pageContextEnabled = true, currentPageContext }) => {
    const [open, setOpen] = useState(false)

    if (!chatbotEnabled) return null

    return (
        <>
            <Tooltip title={open ? 'Close chat' : 'Chat'}>
                <Box
                    component="button"
                    onClick={() => setOpen((prev) => !prev)}
                    aria-label={open ? 'Close chat' : 'Open chat'}
                    sx={fabStyles(align)}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Icon
                            name="EidLogo"
                            style={{
                                width: 28,
                                height: 28,
                            }}
                        />
                        {open && <Box sx={statusDotStyles} aria-hidden />}
                    </Box>
                </Box>
            </Tooltip>
            <ChatBot
                open={open}
                onClose={() => setOpen(false)}
                locale={locale}
                onExplainRequest={() => setOpen(true)}
                align={align}
                pageContextEnabled={pageContextEnabled}
                currentPageContext={currentPageContext}
            />
        </>
    )
}

export default ChatBotFloatingTrigger
